import Badge from './badge';
import Button from './button';
import Card from './card';
import Container from './container';
import Divider from './divider';
import Form from './form-control';
import FormLabel from './form-label';
import Heading from './heading';
import Input from './input';
import Menu from './menu';
import Modal from './modal';
import Navigator from './navigator';
import Radio from './radio';
import Select from './select';
import Stepper from './stepper';
import Table from './table';
import Tabs from './tabs';
import Tag from './tag';

const components = {
  Card,
  Modal,
  Badge,
  Button,
  Container,
  Divider,
  Form,
  FormLabel,
  Heading,
  Input,
  Menu,
  Navigator,
  Radio,
  Select,
  Stepper,
  Table,
  Tabs,
  Tag
};

export default components;